const config: {
  severityTypes: string[]
} = {
  severityTypes: ['info', 'error', 'warning', 'debug', 'critical']
}

export default config
